<template>
  <div>
    <input type="text" ref="touchInput"
           :name="name"
           :class="'input-text'"
           :value="value"
           :disabled="disabled"
           @input="updateValue()"
           @click="onClick" />
  </div>
</template>

<script>
    import $ from 'jquery'
    import touchspin from '../assets/Bootstrap/jquery.bootstrap-touchspin.min'

    export default {
        name: "touch-spin",

        props: ['name', 'value', 'decimals', 'step', 'max', 'min', 'disabled', 'defaultValue'],

        $_veeValidate: {
            value () {
                return this.$refs.touchInput.value;
            },
            name () {
                return this.name;
            }
        },

        data(){
            return{
                parentGroup: null
            }
        },

        watch:{
            max(n, o){
                let newVal = parseFloat(n);
                if(newVal){
                    $(this.$refs.touchInput).trigger("touchspin.updatesettings", {max: newVal});
                }
            }
        },

        methods:{
            updateValue() {
                if (!this.$refs.touchInput.value || this.$refs.touchInput.value === '-' || isNaN(parseFloat(this.$refs.touchInput.value))) {
                    this.$emit('input', this.$refs.touchInput.value);
                } else if (this.decimals > 0) {
                    this.$emit('input', parseFloat(this.$refs.touchInput.value));
                } else {
                    this.$emit('input', parseInt(this.$refs.touchInput.value));
                }
            },

            onClick($event){
                this.$emit('click', $event);
            }
        },

        mounted () {
            //console.info('touch-spin -> mounted -> vm.$el:', this.$el)
            let vm = this;
            this.$nextTick(() => {
                let options = {
                  verticalbuttons: true,
                  min: vm.min || 0,
                  max: vm.max || 1000000000,
                  decimals: vm.decimals
                };
                if(vm.step){
                    options.step = vm.step;
                }
                if (vm.$refs.touchInput !== undefined) {
                    let inputCssClass = vm.$refs.touchInput.className;
                    $(vm.$refs.touchInput).TouchSpin(options).on('change', function (e, s) {
                        vm.updateValue();
                        if(vm.defaultValue !== undefined && isNaN(parseFloat(vm.$refs.touchInput.value))) {
                            vm.$refs.touchInput.value = vm.defaultValue;
                            vm.$emit('input', parseInt(vm.$refs.touchInput.value));
                        }
                        vm.$emit('change', vm.$refs.touchInput.value);
                    });
                    let wrapper = $(vm.$refs.touchInput).parent().parent();
                    wrapper.removeClass(inputCssClass);
                }
            });
        },

        beforeDestroy() {
            let vm = this;
            this.$nextTick(() => {
                $(vm.$refs.touchInput).trigger('touchspin.destroy');
            })
        }
    }
</script>

<style scoped>
    @import '../assets/Bootstrap/jquery.bootstrap-touchspin.min.css';
</style>


// WEBPACK FOOTER //
// Content/src/components/Touchspin.vue